<template>
  <v-container grid-list-md>
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      max-width="400px"
      transition="dialog-transition"
    >
      <template v-slot:activator="{}">
        <v-btn
          fab
          :loading="loading"
          color="success"
          dark
          @click="onOpenExpense"
        >
          <v-icon>fas fa-hands-helping</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          NEW PROPERTY
          <v-spacer></v-spacer>
          <v-btn text icon @click.stop="close">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-form ref="form" v-model="valid" class="mx-5">
          <v-text-field
            outlined
            v-model.trim="Propery.PropertyName"
            :rules="[v => !!v || 'Property Name is required']"
            label="Property Name"
            color="success"
            prepend-inner-icon="fas fa-briefcase"
            required
          >
          </v-text-field>

          <v-select
            outlined
            :loading="loading"
            v-model.trim="Propery.PropertyType"
            :rules="[v => !!v || 'Property Type is required']"
            :items="Properties"
            item-text="AccountName"
            item-value="_id"
            label="Property Type"
            prepend-inner-icon="fas fa-folder-plus"
            @click:prepend-inner="OnNewExpense"
            required
            no-data-text="No property type is availble"
          ></v-select>

          <v-text-field
            outlined
            v-model="Propery.Info"
            :rules="[v => !!v || 'Info is required']"
            label="Info"
            prepend-inner-icon="fas fa-comment-alt"
            required
          >
          </v-text-field>
          <!-- <small class="text-center warning white--text d-block"
            >Note the Propery amount is based on
            <strong class="black--text">{{ UsersToken.CashBase }}</strong>
          </small> -->
        </v-form>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn
            :color="isEditing ? 'error' : 'teal'"
            class=" white--text"
            width="200px"
            :loading="clicked"
            @click="UpdateOrSave"
          >
            {{ isEditing ? "Update" : "Register" }}
            <!-- <v-icon right>fas fa-plus</v-icon> -->
          </v-btn>
        </v-card-actions>
        <NewProperty
          :loadFunction="onOpenExpense"
          :AccountType="15"
          title="New Property type"
          @OnClosed="OpenExpense = false"
          :OpenNewExpense="OpenExpense"
        >
        </NewProperty>
        <p v-if="ErrorMsg" class="red--text d-flex mt-2 justify-center">
          {{ ErrorMsg }}
        </p>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: {
    loadFunction: { type: Function, required: true },
    isEditing: { type: Boolean, required: true, default: false },
    OnEdite: { type: Object, required: true },
  },
  components: {
    NewProperty: () => import("@/components/util/NewAccount.vue"),
  },
  data() {
    return {
      ID: "",
      BaseURL: "/qarash/investment",
      dialog: false,
      loading: false,
      clicked: false,
      OpenExpense: false,
      valid: true,
      date: null,
      Properties: [],
      ErrorMsg: "",
      Propery: {
        PropertyName: null,
        PropertyType: null,
        Info: null,
      },
    };
  },

  computed: {
    ...mapGetters(["UsersToken"]),
  },
  watch: {
    isEditing(val) {
      // console.log(val);
      if (val) {
        // this.dialog = true;
        this.onOpenExpense();
        this.ExpenEdite(this.OnEdite);
      }
    },
  },

  methods: {
    ExpenEdite(E_exp) {
      // console.log(E_exp);
      this.ID = E_exp._id;
      this.ErrorMsg = "";
      this.Propery.PropertyName = E_exp.PropertyName;
      this.Propery.PropertyType = E_exp.PropertyType;
      this.Propery.Info = E_exp.Info;
    },
    close() {
      // console.log("colosed");
      this.dialog = false;
      this.ID = null;
      this.Propery.PropertyName = null;
      this.Propery.Info = null;
      this.Propery.PropertyType = null;

      this.$emit("input", false);

      this.$refs.form.resetValidation();
      // this.loadFunction();
    },
    UpdateOrSave() {
      if (this.isEditing) this.OnUpdateExpense();
      else this.OnSaveExpense();
    },
    GetAccounts(url, query) {
      if (!url) url = "/Account";
      if (!query) query = { acc: [{ AccountType: 15 }] };
      return this.$store.dispatch("FIND_BY_VALUE", {
        url,
        query,
      });
    },
    // GetReq(url = "/Propery", query = { fixed: true }) {
    //   return this.$store.dispatch("FIND_BY_VALUE", {
    //     url,
    //     query
    //   });
    // },
    OnNewExpense() {
      this.OpenExpense = true;
    },
    onOpenExpense() {
      this.loading = true;
      this.GetAccounts()
        .then(exp => {
          this.loading = false;
          // console.log(exp);
          this.Properties = exp.data;
          this.dialog = true;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        });
      // console.log(this.UsersToken);
    },

    OnUpdateExpense() {
      // console.log("Updating");
      this.ErrorMsg = "";
      if (this.$refs.form.validate() && this.ID) {
        this.clicked = true;
        this.$store
          .dispatch("UPDATE_ONLY", {
            url: this.BaseURL,
            data: { ...this.Propery, ID: this.ID },
          })
          .then(() => {
            this.clicked = false;
            // this.$refs.SupplierForm.reset();
            // console.log(result);
            this.ID = "";
            this.loadFunction();
            this.close();
          })
          .catch(err => {
            this.clicked = false;
            if (err.response && err.response.data)
              this.ErrorMsg = err.response.data;
            // console.log(err);
          });
      }
    },
    OnSaveExpense() {
      try {
        if (this.$refs.form.validate()) {
          this.clicked = true;
          // console.log(this.Propery);

          this.$store
            .dispatch("INSERT_ONLY", {
              url: this.BaseURL,
              data: this.Propery,
            })
            .then(() => {
              this.loadFunction();
              this.close();
              // this.$refs.form.reset();
              this.clicked = false;
              // console.log(result);
            })
            .catch(err => {
              this.clicked = false;
              // console.log(err.response);
              if (err.response.status === 400)
                this.ErrorMsg = err.response.data;
              if (err.response.status === 409)
                this.ErrorMsg = this.Propery.PropertyName + " is registred";
              else this.ErrorMsg = err.response.data;
            });
        }
      } catch (error) {
        console.log(error);
      }
      this.ErrorMsg = "";
    },
  },
  // created() {
  //   console.log(this.Current());
  //   console.log("Date");
  // }
};
</script>
